import {Component, Input, OnInit} from '@angular/core';
import {Card} from '../../../../../models/shared/stylesheet/card';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() card: Card;
  @Input() cardClass: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
